import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  isLoggedIn: false,
  UserId: "",
  UserBranch: "",
  UserName: "",
  UserEmail: "",
  UserJobTitle: "",
  UserStatus: "",
  UserSection: "",
  UserSubSection: "",
  UserSubSectionSub : "",
  UserPermission: [],
  UserRole: "",
  UserTeam: "",
  UserOnlineStatus: "",
  UserAccessToken: "",
  UserRefreshToken: "",
  GoogleConnected: false,
};
const Reducer = createSlice({
  name: "Auth",
  initialState,
  reducers: {
    Login: (state, action) => {
      return {
        ...state,
        isLoggedIn: true,
        ...action.payload,
      };
    },
    Logout: () => {
      return initialState;
    },
    SetAccessToken: (state, action) => {
      
      return {
        ...state,
        UserAccessToken: action.payload,
      };
    },
    UpdateUserData: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export default Reducer.reducer;
export const { Login, Logout, UpdateUserData } = Reducer.actions;
